import styled from 'styled-components';

export const IssueSearchActionsPageStyled = styled.div`
  margin: 8px 0;
`;

export const MenuItem = styled.p`
  margin: 0;
  padding: 6px 16px;

  &:hover {
    cursor: pointer;
    background: var(
      --ds-surface-overlay-hovered,
      var(--ds-fb-surface-overlay-hovered)
    );
  }
`;
